<template>
  <b-modal
    :id="modalId"
    size="md"
    no-enforce-focus
    hide-footer
    hide-header
    body-class="p-3"
    @shown="onShown"
    @hidden="onHidden"
  >
    <div class="text-right">
      <b-button v-if="false && isAdmin && !editing" variant="link" size="sm" class="text-muted" @click="onClickEdit">
        <i class="fa fa-fw fa-edit"></i>
      </b-button>
      <b-button v-if="false && isAdmin && !editing" variant="link" size="sm" class="text-muted" @click="onClickDelete">
        <i class="fa fa-fw fa-trash"></i>
      </b-button>
      <b-button variant="link" size="sm" class="text-muted" @click="onClickClose">
        <i class="fa fa-fw fa-times"></i>
      </b-button>
    </div>
    <b-row v-if="!!event" align-h="center">
      <b-col class="col-12 col-md-10">
        <h5 class="mb-0">{{ event.title }}</h5>
        <p class="text-muted">
          {{ event.allDay ? dateRangeStr(event.start, event.end, false, true) : timeRangeStr(event.start, event.end) }}
        </p>
        <div v-if="!!event.extendedProps.location" v-html="event.extendedProps.location"></div>
        <div v-if="!!event.extendedProps.subtitle" v-html="event.extendedProps.subtitle"></div>
        <div v-if="!!popup_description" v-html="popup_description"></div>
        <div v-if="!!event.extendedProps.description" v-html="event.extendedProps.description" class="my-4"></div>
        <div v-if="!!event.extendedProps.button_text && event.extendedProps.button_url" class="mb-4">
          <b-button variant="branded" :href="event.extendedProps.button_url"
                    :target="event.extendedProps.button_target || 'popup'" @click="onClickButton">
            {{ event.extendedProps.button_text || trans('filled_form') }}
          </b-button>
        </div>
        <div v-if="!!event.extendedProps.address">
          <p class="mb-1">
            <a
              :href="`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(event.extendedProps.address)}`"
              target="_blank">
              {{ event.extendedProps.address }}
              <i class="fa fa-fw fa-external-link-alt"></i>
            </a>
          </p>
          <b-img v-if="!!event.extendedProps.map_image_url" fluid :src="event.extendedProps.map_image_url"/>
        </div>
        <p v-if="isPreview && canEditEventPopupDescription">
          <b-button variant="outline-primary" size="sm" class="py-0" @click="onClickEditEventPopupDescription">
            <i class="fa fa-fw fa-edit"></i>
            {{ trans('description') }}
          </b-button>
        </p>
      </b-col>
    </b-row>
    <br/>
    <html-textarea-modal
      id="page-calendar-edit-event-calendar-description"
      :organization="organization"
      v-model="event_popup_description"
      show-insert-form-document
      :url="eventPopupDescriptionUrl"
      attr="calendar_description"
      :label="trans('event_additional_information_in_popup')"
      @input="onSaveEventPopupDescription($event)"
    ></html-textarea-modal>
  </b-modal>
</template>

<script>
import HtmlTextareaModal from './../../../common/components/HtmlTextareaModal'

export default {
  props: {
    organization: Object,
    page: Object,
    block: Object,
    event: Object,
    modalId: {
      type: String,
      default: 'page-calendar-event-modal',
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HtmlTextareaModal,
  },
  data() {
    return {
      trans: trans,
      dateRangeStr: _.dateRangeStr,
      timeRangeStr: _.timeRangeStr,
      busy: false,
      error: null,
      popup_description: null,
      event_popup_description: null,
    }
  },
  computed: {
    isAdmin() {
      return !!this.organization && !!this.organization.auth_user
    },
    canEditEventPopupDescription() {
      if (!this.isPreview || !this.event || !this.event.extendedProps || !this.event.extendedProps.type) return false
      return !!this.event.extendedProps && ['date', 'date_range', 'time_track', 'booking'].indexOf(this.event.extendedProps.type) >= 0 ||
        this.event.extendedProps.type == 'am_class' && !this.event.extendedProps.form_url
    },
    eventPopupDescriptionUrl() {
      if (!this.event || !this.event.extendedProps || !this.event.extendedProps.type) return null
      if (['date', 'date_range', 'time_track'].indexOf(this.event.extendedProps.type) >= 0)
        return `/organization/${this.organization.id}/checkout_form/${this.event.extendedProps.form_id}/answer/${this.event.extendedProps.answer_id}/calendar_description`
      if (this.event.extendedProps.type == 'am_class')
        return `/organization/${this.organization.id}/event/${this.event.extendedProps.am_class_id}/event/${this.event.id}/calendar_description`
      if (this.event.extendedProps.type == 'booking')
        return `/organization/${this.organization.id}/booking/${this.event.extendedProps.booking_id}/event/${this.event.extendedProps.event_id}/calendar_description`
    },
  },
  methods: {
    onShown() {
      this.loadPopupDescription()
    },
    onHidden() {
      this.busy = false
      this.error = null
      this.popup_description = null
      this.event_popup_description = null
    },
    loadPopupDescription() {
      if (!this.page ||
        !this.block ||
        !this.block.meta ||
        !this.block.meta.event_sources)
        return
      if (!this.event ||
        !this.event.extendedProps ||
        ['date', 'date_range', 'time_track'].indexOf(this.event.extendedProps.type) === -1 ||
        this.event.extendedProps.block_id != this.block.id ||
        !this.event.extendedProps.recipient_id)
        return
      let event_source = _.find(this.block.meta.event_sources, {id: this.event.extendedProps.event_source_id})
      if (!event_source ||
        !event_source.popup_description)
        return

      this.busy = true
      this.error = null
      let slug = (this.page.slug || '').replace('/', '') || 'undefined'
      if (this.isPreview) {
        let url = `/organization/${this.organization.id}/page/${this.page.id}/simulate_calendar_event_popup_description/${this.event.extendedProps.recipient_id}/${event_source.id}`
        axios.post(url, this.block)
          .then(response => {
            this.busy = false
            this.popup_description = response.data.popup_description
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
          })
      } else {
        let url = `/org/${this.organization.id}/page/${this.page.upid}/${slug}/calendar_event_popup_description/${this.block.id}/${this.event.extendedProps.recipient_id}/${event_source.id}`
        axios.get(url)
          .then(response => {
            this.busy = false
            this.popup_description = response.data.popup_description
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
          })
      }
    },
    onClickEditEventPopupDescription() {
      if (!this.event || !this.event.extendedProps || !this.event.extendedProps.type) return
      if (this.event.extendedProps.type == 'am_class')
        this.event_popup_description = this.event.extendedProps.calendar_description
      else
        this.event_popup_description = this.event.extendedProps.description
      this.$bvModal.show('page-calendar-edit-event-calendar-description')
    },
    onSaveEventPopupDescription(description) {
      this.$bvModal.hide(this.modalId)
      this.$emit('updated')
    },
    onClickButton(e) {
      if (this.event.extendedProps.button_target == 'popup') {
        e.preventDefault()
        window.formIframeModalUpid = _.extractUpidFromUrl(this.event.extendedProps.button_url)
        this.$bvModal.show('form-iframe-modal')
      }
    },
    onClickDelete() {
      this.$bvModal.msgBoxConfirm(trans('delete_confirm'), {
        title: trans('delete'),
        okTitle: trans('delete'),
        okVariant: 'danger',
        cancelTitle: trans('cancel'),
      })
        .then(confirmed => {
          if (!confirmed) return
          this.$emit('delete', this.serialized)
          this.$bvModal.hide(this.modalId)
        })
    },
    onClickEdit() {
      this.$emit('edit', this.event)
      this.$bvModal.hide(this.modalId)
    },
    onClickClose() {
      this.$bvModal.hide(this.modalId)
    },
  },
  mounted() {
    window.pageCalendarEventModal = this
  },
}
</script>
